export default "__VITE_ASSET__B8xyFBIP__"